import { TuiHintModule } from '@taiga-ui/core';
import { Component, inject } from '@angular/core';
import { NgIf } from '@angular/common';

import { ISS_SUPPORT_LINK } from './contact-support.config';

import { environment } from '@wo-environments';
import { SideNavComponent, SideNavMenuItemComponent } from '@iss/core/portal';
import { IconComponent } from '@iss/core/icon';

@Component({
  selector: 'wo-contact-support',
  templateUrl: './contact-support.component.html',
  styleUrls: [ './contact-support.component.scss' ],
  standalone: true,
  imports: [
    IconComponent,
    NgIf,
    SideNavMenuItemComponent,
    TuiHintModule,
  ],
})
export class ContactSupportComponent {
  private readonly sideNav = inject(SideNavComponent);
  public readonly email = environment.support.email;
  public readonly phone = environment.support.phone;
  public readonly supportLink = inject(ISS_SUPPORT_LINK, { optional: true });

  public openPhone(): void {
    window.open(`tel:${ this.phone }`, '_blank');
  }

  public openEmail(): void {
    window.open(`mailto:${ this.email }`, '_blank');
  }

  public openSupport(supportLink: string): void {
    window.open(supportLink, '_blank', 'noopener noreferrer');
  }

  public get expanded(): boolean {
    return Boolean(this.sideNav.expanded);
  }
}
